// import React from "react";

// export default function MediaActions({
//   allValues,
//   handleReset,
//   handleSave,
//   selectedValue,
//   handleInputChange,
// }) {
//   return (
//     <div>
//       {/* Media Status Section */}
//       <form className="grid grid-cols-2">
//         {["isfeatured", "ismultifaced", "ispremium", "istrending"].map(
//           (field) => (
//             <CheckboxField
//               key={field}
//               label={field
//                 .replace(/^is/, "")
//                 .replace(/([a-z])([A-Z])/g, "$1 $2")
//                 .replace(/^./, (str) => str.toUpperCase())}
//               name={field}
//               checked={selectedValue[field]}
//               onChange={handleInputChange}
//             />
//           ),
//         )}
//         <div className="mb-4 w-[200px]">
//           <select
//             name="platform"
//             value={"ALL"}
//             // onChange={handleInputChange}
//             className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
//           >
//             <option value="ALL">ALL</option>
//             <option value="IOS">IOS</option>
//             <option value="AND">AND</option>
//             <option value="WEB">WEB</option>
//           </select>
//         </div>
//       </form>

//       <div className="flex flex-col gap-5">
//         <button
//           onClick={handleReset}
//           disabled={allValues.length === 0}
//           className={`w-full max-w-[269px] cursor-pointer text-nowrap rounded-[10px] border border-[#0075FF] bg-[#0075FF] decoration-slice px-[89px] py-[15px] text-center font-outfit text-[16px] font-medium leading-[20.16px] text-[#FFFFFF]`}
//         >
//           Reset
//         </button>
//         <button
//           onClick={handleSave}
//           disabled={allValues.length === 0}
//           className={`w-full max-w-[269px] text-nowrap rounded-[10px] border border-[#0075FF] decoration-slice px-[89px] py-[15px] text-center font-outfit text-[16px] font-medium leading-[20.16px] text-[#0075FF] ${
//             allValues.length === 0
//               ? "cursor-not-allowed opacity-50"
//               : "cursor-pointer opacity-100"
//           }`}
//         >
//           Submit Data
//         </button>
//       </div>
//     </div>
//   );
// }

// const CheckboxField = ({ label, name, checked, onChange }) => {
//   return (
//     <>
//       <div className="mb-[20px] mt-[20px] flex w-[300px] items-center gap-4 text-left font-outfit text-[14px] font-normal leading-[17.64px] text-[#666666]">
//         <label htmlFor={name} className="cursor-pointer">
//           {label}
//         </label>
//         <input
//           type="checkbox"
//           id={name}
//           name={name}
//           checked={checked}
//           className="h-[16px] w-[16px]"
//           onChange={onChange}
//         />
//       </div>
//     </>
//   );
// };

import React from "react";
import Dropdown from "../common/dropdown";

export default function MediaActions({
  allValues,
  handleReset,
  handleSave,
  selectedValue,
  handleInputChange,
}) {
  console.log(selectedValue);

  return (
    <div>
      {/* Media Status Section */}
      <form className="grid grid-cols-2">
        {["isfeatured", "ismultifaced", "ispremium", "istrending"].map(
          (field) => (
            <CheckboxField
              key={field}
              label={field
                .replace(/^is/, "")
                .replace(/([a-z])([A-Z])/g, "$1 $2")
                .replace(/^./, (str) => str.toUpperCase())}
              name={field}
              checked={selectedValue[field]}
              onChange={handleInputChange}
            />
          ),
        )}
      </form>
      {/* Platform Dropdown */}
      <div className="mb-4 mt-[20px] w-[200px]">
        <Dropdown
          name="premiumfor"
          value={selectedValue.premiumfor}
          onChange={handleInputChange}
          items={[
            { category_id: "ALL", category_name: "ALL" },
            { category_id: "IOS", category_name: "IOS" },
            { category_id: "AND", category_name: "AND" },
            { category_id: "WEB", category_name: "WEB" },
          ]}
          className="w-[200px]"
        />
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col gap-5">
        <button
          onClick={handleReset}
          disabled={allValues.length === 0}
          className={`w-full max-w-[269px] cursor-pointer text-nowrap rounded-[10px] border border-[#0075FF] bg-[#0075FF] decoration-slice px-[89px] py-[15px] text-center font-outfit text-[16px] font-medium leading-[20.16px] text-[#FFFFFF]`}
        >
          Reset
        </button>
        <button
          onClick={handleSave}
          disabled={allValues.length === 0}
          className={`w-full max-w-[269px] text-nowrap rounded-[10px] border border-[#0075FF] decoration-slice px-[89px] py-[15px] text-center font-outfit text-[16px] font-medium leading-[20.16px] text-[#0075FF] ${
            allValues.length === 0
              ? "cursor-not-allowed opacity-50"
              : "cursor-pointer opacity-100"
          }`}
        >
          Submit Data
        </button>
      </div>
    </div>
  );
}

const CheckboxField = ({ label, name, checked, onChange }) => {
  return (
    <div className="mb-[20px] mt-[20px] flex w-[300px] items-center gap-4 text-left font-outfit text-[14px] font-normal leading-[17.64px] text-[#666666]">
      <label htmlFor={name} className="cursor-pointer">
        {label}
      </label>
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        className="h-[16px] w-[16px]"
        onChange={onChange}
      />
    </div>
  );
};
